import React from 'react';
import { Grid } from '@material-ui/core';
import { Security, Email, EmojiObjects } from '@material-ui/icons';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import './AboutUs.css';

const AboutPhishCloud = (props) => {
  useChangePageTitle('AboutUs');

  const preferredLanguage = props.preferredLanguage;
  const getTranslation = props.getTranslation || ((value) => value);

  return (
    <div className="aboutUsRoot">
      <div className="aboutUsHero">
        <h2 className="aboutUsHeroTitle">
          {getTranslation('About Us', preferredLanguage)}
        </h2>
        <p className="aboutUsHeroSubtitle">
          {getTranslation('At', preferredLanguage)} <strong>PhishCloud</strong>{' '}
          {getTranslation(
            'we believe that our users are an integral part of protection from phishing and need strong tools to be effective.',
            preferredLanguage
          )}
        </p>
      </div>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <div className="aboutUsCard">
            <div className="aboutUsCardContent">
              <div className="aboutUsIconWrapper aboutUsIconAI">
                <EmojiObjects />
              </div>
              <h3 className="aboutUsCardTitle">
                {getTranslation('AI-Powered Protection', preferredLanguage)}
              </h3>
              <p className="aboutUsCardBody">
                {getTranslation(
                  'Rather than expecting our users to determine if a link is safe or unsafe; using our Artificial Intelligence backend, PhishCloud Agents integrate with applications to automatically determine link safety and notify users before they click on a malicious link.',
                  preferredLanguage
                )}
              </p>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <div className="aboutUsCard">
            <div className="aboutUsCardContent">
              <div className="aboutUsIconWrapper aboutUsIconEmail">
                <Email />
              </div>
              <h3 className="aboutUsCardTitle">
                {getTranslation('Email Integration', preferredLanguage)}
              </h3>
              <p className="aboutUsCardBody">
                {getTranslation(
                  'We support automated phishing analysis and notification for several email providers including Gmail, Outlook (Office365) and Hotmail.',
                  preferredLanguage
                )}
              </p>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <div className="aboutUsCard">
            <div className="aboutUsCardContent">
              <div className="aboutUsIconWrapper aboutUsIconShield">
                <Security />
              </div>
              <h3 className="aboutUsCardTitle">
                {getTranslation('Universal Link Safety', preferredLanguage)}
              </h3>
              <p className="aboutUsCardBody">
                {getTranslation(
                  'For all other websites, PhishCloud Agents integrate with applications to provide right-click functionality, allowing you to check the safety of any link.',
                  preferredLanguage
                )}
              </p>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default AboutPhishCloud;
